'use client';

import { createContext } from 'react';

import type { ToastContextInterface } from '../types/toast-root.types';

export const ToastContext = createContext<ToastContextInterface>({});

ToastContext.displayName = 'Toast.Context';
